import React from "react";
import { Button } from "@culturehq/components";
import { Trans } from "app/utils";

import { TimeDiff } from "components/common/Time";
import ChqModalConfirmDelete from "components/common/ChqModalConfirmDelete";

import PrivacyPolicyModal from "./PrivacyPolicyModal";
import { PrivacyPolicy } from "./PrivacyPolicyTypes";

interface PrivacyPolicyRowProps {
  privacyPolicy: PrivacyPolicy;
  onUpdate: (privacyPolicy: PrivacyPolicy) => void;
  onDelete: (privacyPolicy: PrivacyPolicy) => void;
}

const PrivacyPolicyRow = ({ privacyPolicy, onUpdate, onDelete }: PrivacyPolicyRowProps) => {
  const { url, text, createdAt, updatedAt } = privacyPolicy;

  return (
    <tr>
      <td>
        <Trans><a href={url} target="_blank" rel="noopener noreferrer">{url}</a></Trans>
      </td>
      <td>
        <Trans>{text}</Trans>
      </td>
      <td>
        <TimeDiff time={createdAt} />
      </td>
      <td>
        <TimeDiff time={updatedAt} />
      </td>
      <td className="Actions-column">
        <PrivacyPolicyModal privacyPolicy={privacyPolicy} onUpdate={onUpdate}>
          {(onTrigger: any) => (
            <Button icon="edit-outlined" onClick={onTrigger} inverted />
          )}
        </PrivacyPolicyModal>
        <ChqModalConfirmDelete
          onAccept={() => onDelete(privacyPolicy)}
          trigger={(onTrigger: any) => (
            <Button icon="trash-a-outlined" onClick={onTrigger} inverted />
          )}
        >
          <Trans>
            Are you sure you would like to delete this privacy policy?
          </Trans>
        </ChqModalConfirmDelete>
      </td>
    </tr>
  );
};

export default PrivacyPolicyRow;
